import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";
import ServicePage from "./pages/ServicePage";
import ChallengePage from "./pages/ChallengePage";
import LearningPage from "./pages/LearningPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import DoNotSell from "./pages/DoNotSell";

function Layout({ children }) {
  return (
    <div className="flex flex-col min-h-screen">
      <TopBar />
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();
      document
        .querySelectorAll('a[href*="emergent.sh"]')
        .forEach((el) => el.remove());
    };

    removeBadge();
    const interval = setInterval(removeBadge, 300);
    const observer = new MutationObserver(removeBadge);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      clearInterval(interval);
      observer.disconnect();
    };
  }, []);
  return (
    <BrowserRouter basename="/nbt">
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="npm run build/about-us" element={<AboutUs />} />
          <Route path="/contact" element={<Contact />} />

          {/* Service pages */}
          <Route path="/marketing-leads" element={<ServicePage />} />
          <Route path="/technology-leads" element={<ServicePage />} />
          <Route path="/nurture-marketing" element={<ServicePage />} />
          <Route path="/database-assessment" element={<ServicePage />} />
          <Route path="/market-survey" element={<ServicePage />} />

          {/* Challenge pages */}
          <Route path="/need-more-leads" element={<ChallengePage />} />
          <Route path="/email-campaign-reports" element={<ChallengePage />} />
          <Route path="/brand-awareness" element={<ChallengePage />} />
          <Route path="/marketing-database" element={<ChallengePage />} />

          {/* Learning Center pages */}
          <Route path="/corporate-brochure" element={<LearningPage />} />
          <Route path="/complete-solution-guide" element={<LearningPage />} />
          <Route path="/case-studies" element={<LearningPage />} />
          <Route path="/white-papers" element={<LearningPage />} />

          {/* Legal pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/do-not-sell" element={<DoNotSell />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
